export default __webpack_public_path__ + "static/media/joystick_filled-min.5e0232ff.png";